import { useRef } from 'react';

import { useLegalClientLegalHeadSaveAddresses } from 'api/requests';
import { useServerErrorNotify } from 'hooks';
import { useOnboardingCountries } from 'modules/onboarding/common/hooks';
import { CompanyAddressFormType } from 'modules/onboarding/legal/forms/companyAddressForm';
import {
  getInitialData,
  getSubmitData,
} from 'modules/onboarding/legal/helpers/companyRegistrationAddress';

import { useOnboardingContext } from './useOnboardingContext';

export const useCompanyRegistrationAddress = () => {
  const {
    error,
    loading: submitLoading,
    saveAddresses,
  } = useLegalClientLegalHeadSaveAddresses();

  const { goToBack, goToNext, data } = useOnboardingContext();

  const { countries, loading: countriesLoading } = useOnboardingCountries();

  const initialValues = useRef(getInitialData(data.legalHead!)?.values).current;

  const onSubmit = async (values: CompanyAddressFormType) => {
    if (values) {
      const submitData = getSubmitData(values);
      await saveAddresses(data.legalClient.id, data.legalHead.id, submitData);
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    onSubmit,
    initialValues,
    countries,
    countriesLoading,
    submitLoading,
    goToBack,
  };
};
